import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@mui/styles';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import download from '../images/download-doc.svg';
import {Button, IconButton} from '@mui/material';
import {withTranslation} from 'react-i18next';
import { ReportToolbar } from "../ReportPageLayout";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
  PHARMACY_REPORT_SORT_MAP,
} from "../../grid/iLocalAGGrid";
import moment from 'moment-timezone';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from '../../../utils/datetime.utils';
import GraphView from './graph-view';
import Loader from './Loader';
import { styles } from './styledComponents';
import {convertToTimeZone} from '../../../utils/datetime.utils';
import {gettingOnSortTableName, } from './helpers/data.helpers';

const __reportDefaultDates = getDefaultDateRange();

let BoxUtitlizationFilterObj = {
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  searchtext: '',
  tableName: '',
  store_ids: null,
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
};

class KioskBoxUtilization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      orderBy: 'created_on',
      page: 0,
      rowsPerPage: 10,
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      searchText: '',
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      loader: false,
      isDataEmpty: true,
      data: [],
      totalRecords: 0,
      isButtonDisabled: false,
      toggleGraph: false,
      selectedYear: new Date().getFullYear() - 1,
      queryId: "",
      groups: [],
      chipstores: [],
      accountValues: [],
      nstores: [],
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.debouceTimeout = null;
  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && BoxUtitlizationFilterObj.pageSize !== newPageSize) {
      BoxUtitlizationFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      sortMap: PHARMACY_REPORT_SORT_MAP,
      filterBody: BoxUtitlizationFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['date'] });
      },
      pageZeroBased: true,
      getPageSize: () => BoxUtitlizationFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "kioskBoxUtilization", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, BoxUtitlizationFilterObj, 'date');
  };

  componentDidMount() {
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    Object.assign(BoxUtitlizationFilterObj, {
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'created_on',
      searchtext: '',
      tableName: '',
      store_ids: [],
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate)
    });
    this.BindBoxUtilization();
    this.fetchAccounts();
  }

  onSearchChange(event) {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchText: searchString && searchString });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.sortOrder = 'desc';
    BoxUtitlizationFilterObj.sortColumn = 'created_on';
    BoxUtitlizationFilterObj.tableName = '';
    BoxUtitlizationFilterObj.store_ids = [];
    BoxUtitlizationFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindBoxUtilization();
    }, 1000);
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/KioskUtilizationReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(BoxUtitlizationFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRow = [];
        let Elements = [
          [
            'Id',
            'Store',
            'Box',
            'Total Bins',
            'Available Bins',
            'Pharmacy Occupied Bins',
            'Optical Occupied Bins',
            'Occupied Bins',
            'Pharmacy Utilization',
            'Optical Utilization',
            'Utilization',
            'Date',
          ],
        ];
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Elements.push([
                i.store,
                i.box,
                i.total_bins,
                i.available_bins,
                i.pharmacy_used_bins,
                i.optical_used_bins,
                i.use_bins,
                i.pharmacy_utilization ? i.pharmacy_utilization + '%' : '',
                i.optical_utilization ? i.optical_utilization + '%' : '',
                i.box_utilization ? i.box_utilization + '%' : '',
                convertToTimeZone(i.utilization_date) || '',
              ]);
            }

            for (let i of Elements) {
              csvRow.push(i.join(','));
            }
            let csvString = csvRow.join('%0A');
            let element = document.createElement('a');
            element.href = 'data:attachment/csv.' + csvString;
            element.target = '_Blank';
            element.download = 'KioskUtilizationReport.csv';
            document.body.appendChild(element);
            element.click();
          }
        }
      });
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ order, orderBy, sortId: property });
    BoxUtitlizationFilterObj.sortOrder = order;
    BoxUtitlizationFilterObj.sortColumn = field;
    BoxUtitlizationFilterObj.tableName = gettingOnSortTableName(orderBy);

    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();

    BoxUtitlizationFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  handleChangeRowsPerPage = (event) => {

    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  BindBoxUtilization() {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + 'kioskBoxUtilization', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(BoxUtitlizationFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({ totalRecords: uData && uData.total });
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({
            data: uData && uData.results,
            loader: uData && uData.total && false,
            isDataEmpty: false,
            isButtonDisabled: false,
          });
        } else {
          this.setState({
            data: null,
            loader: false,
            isDataEmpty: true,
            isButtonDisabled: true,
          });
        }
      });
  }

  fetchAccounts = async () => {
    await fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const {t} = this.props
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
      });
  }

  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');

    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    BoxUtitlizationFilterObj.store_ids = storeids;
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.sortOrder = 'desc';
    BoxUtitlizationFilterObj.sortColumn = 'created_on';
    BoxUtitlizationFilterObj.tableName = '';

    this.BindBoxUtilization();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      BoxUtitlizationFilterObj.store_ids = [];
      BoxUtitlizationFilterObj.pageNo = 0;
      this.BindBoxUtilization();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.setState({ store_id: storeids });
    BoxUtitlizationFilterObj.store_ids = storeids;
    BoxUtitlizationFilterObj.pageNo = 0;
    this.BindBoxUtilization();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    BoxUtitlizationFilterObj.store_ids = [];
    BoxUtitlizationFilterObj.pageNo = 0;
    this.BindBoxUtilization();
  };

  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindBoxUtilization();
  };

  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindBoxUtilization();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindBoxUtilization();
  }

  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindBoxUtilization();
  }

  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;

    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });

    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    BoxUtitlizationFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindBoxUtilization();
  };

  render() {
    const {t} = this.props;
    const {isButtonDisabled, toggleGraph} = this.state;

    return (
      <Paper>
        {this.state.loader ? <Loader /> : null}
        <div>
          {toggleGraph ? (
            <React.Fragment>
              <div
                style={{
                  margin: '10px',
                  display: 'flex',
                  alighItem: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Button
                  style={{
                    width: '15%',
                    borderBottom: 'none',
                  }}
                  onClick={() => {
                    this.setState({ toggleGraph: false });
                  }}
                >
                  Table View
                </Button>
              </div>
              <GraphView
                setLoader={(val) => {
                  this.setState({ loader: val });
                }}
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <ReportToolbar>
                <Button
                  onClick={() => {
                    this.setState({ toggleGraph: true });
                  }}
                >
                  Graph View
                </Button>
                <Tooltip
                  title={t('Report.KioskUtil.ExportCSVTooltip')}
                  style={{ marginRight: '0' }}
                  aria-label="ExportCSV"
                >
                  <IconButton disabled={isButtonDisabled}>
                    <img
                      alt="download"
                      src={download}
                      onClick={() => this.exportCSV()}
                      style={{
                        height: '32px',
                        width: '32px',
                        cursor: 'pointer',
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </ReportToolbar>
              <ILocalAGGrid
            columnDefs={[
              { field: 'store', headerName: t("Report.KioskUtil.Store"), colId: 'store' },
              { field: 'box', headerName: t("Report.KioskUtil.Box"), colId: 'box' },
              { field: 'total_bins', headerName: t("Report.KioskUtil.TotalBins"), colId: 'totalbins' },
              { field: 'available_bins', headerName: t("Report.KioskUtil.AvailableBins"), colId: 'availablebins' },
              { field: 'pharmacy_used_bins', headerName: "Pharmacy Occupied Bins", colId: 'pharmacyOccupiedBins' },
              { field: 'optical_used_bins', headerName: "Optical Occupied Bins", colId: 'opticalOccupiedBins' },
              { field: 'use_bins', headerName: "Occupied Bins", colId: 'Occupied' },
              { field: 'pharmacy_utilization', headerName: 'Pharmacy Utilization', colId: 'pharmacyUtilization', valueFormatter: (p) => `${![undefined,'undefined',null,'null',''].includes(p.value) ? p.value : 0}%` },
              { field: 'optical_utilization', headerName: 'Optical Utilization', colId: 'opticalUtilization', valueFormatter: (p) => `${![undefined,'undefined',null,'null',''].includes(p.value) ? p.value : 0}%` },
              { field: 'box_utilization', headerName: t("Report.KioskUtil.Utilization"), colId: 'utilization', valueFormatter: (p) => `${![undefined,'undefined',null,'null',''].includes(p.value) ? p.value : 0}%` },
              withDateColumnFilter({ field: 'utilization_date', headerName: t("Report.KioskUtil.Date"), colId: 'date', valueFormatter: (p) => p.value ? convertToTimeZone(p.value) : '' }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={BoxUtitlizationFilterObj.pageSize || 10}
            paginationPageSize={BoxUtitlizationFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
            </React.Fragment>
          )}
        </div>
      </Paper>
    );
  }
}

KioskBoxUtilization.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(KioskBoxUtilization));



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/index.js